import Ajax from './ajax';

const FETCH_URL = import.meta.env['VITE_APP_ENV'] === 'production' 
  ? 'https://autofill.benable.com' 
  : 'https://staging-autofill.benable.com';

async function fetchFast(q, localized = true, preferAffiliate = false, preferAffiliateTopCount = 3) {
  let resp = await Ajax.get({
    url: `${FETCH_URL}/fast`,
    data: {
      query: q,
      localized: localized,
      prefer_affiliate: preferAffiliate,
      prefer_affiliate_top_count: preferAffiliateTopCount,
    },
  });

  return resp;
}

async function fetchSlow(id) {
  let resp = await Ajax.get({
    url: `${FETCH_URL}/slow`,
    data: { id: id },
  });

  return resp;
}

async function fetchImages(id) {
  let resp = await Ajax.get({
    url: `${FETCH_URL}/images`,
    data: { id: id },
  });

  return resp;
}

async function fetchImagesFromUrl(url) {
  let resp = await Ajax.get({
    url: `${FETCH_URL}/images_from_url`,
    data: { url: url },
  });

  return resp;
}

async function fetchExistingRecObject(id) {
  let resp = await Ajax.get({
    url: `${FETCH_URL}/existing_rec_object`,
    data: { id: id },
  });

  return resp;
}

export default {
  fetchFast,
  fetchSlow,
  fetchImages,
  fetchImagesFromUrl,
  fetchExistingRecObject,
};
